module.exports = __webpack_public_path__ + "static/media/unbound-banner.a2b7390d.jpg";